export default __webpack_public_path__ + "img/img_5.2f588283.png";